function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 17c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm3.93-1.886c.206.184.225.5.041.706-.183.206-.5.225-.706.042-1.858-1.653-4.66-1.653-6.518 0-.206.183-.522.164-.706-.042-.183-.206-.165-.522.042-.706 2.237-1.989 5.61-1.989 7.847 0zm2.898-2.873c.202.189.212.505.024.707-.19.201-.505.212-.707.023-3.444-3.22-8.796-3.22-12.24 0-.202.189-.518.178-.707-.023-.188-.202-.178-.518.024-.707 3.829-3.58 9.777-3.58 13.606 0zm2.529-3.179c.206.184.224.5.04.706-.184.206-.5.224-.706.04-4.945-4.41-12.413-4.41-17.358 0-.206.184-.522.166-.706-.04-.184-.206-.166-.522.04-.706 5.325-4.75 13.365-4.75 18.69 0z"
});

var SvgIconWifi = function SvgIconWifi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconWifi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-wifi.fc9d0e79.svg";
export { ForwardRef as ReactComponent };